import { composeIO } from 'react-compose-io'
import { opsEmAbertoResumoIO } from './OpsEmAbertoResumo.IO'
import { OpsEmAbertoResumoView } from './OpsEmAbertoResumo.View'

export const OpsEmAbertoResumo = composeIO(OpsEmAbertoResumoView, opsEmAbertoResumoIO)
